import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../../../types/store';

import { changePage, changeRegion } from '../../../../store/filters/actions';
import { fetchCachedGeocode, fetchRegionsCities } from '../../../../store/geo/thunkActions';

import { MobileLocationSwitcher } from '.';
import { ICity, IGeo } from '../../../../store/geo';

export interface IMobileLocationSwitcherStoreProps {
  geo: IGeo;
  filtersCleared: boolean;
}

export interface IMobileLocationSwitcherDispatchProps {
  changeRegion(region: ICity): void;
  fetchCachedGeocode(request: string): void;
  fetchRegionsCities(text: string): void;
  refreshPage(curPage: number, shouldNotLoadData?: boolean): void;
  refreshRegions(region: ICity, loadNeeded?: boolean): void;
}

export type TMobileLocationSwitcherProps = IMobileLocationSwitcherStoreProps & IMobileLocationSwitcherDispatchProps;

export function mapStateToProps(state: IApplicationState): IMobileLocationSwitcherStoreProps {
  const {
    geo,
    mobile: { filtersCleared },
  } = state;

  return {
    geo,
    filtersCleared,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IMobileLocationSwitcherDispatchProps {
  return {
    changeRegion: city => dispatch(changeRegion(city, true)),
    fetchCachedGeocode: request => dispatch(fetchCachedGeocode({ request })),
    fetchRegionsCities: text => dispatch(fetchRegionsCities(text)),
    refreshPage: (curPage, shouldNotLoadData) => dispatch(changePage(curPage, shouldNotLoadData)),
    refreshRegions: (city, loadNeeded) => dispatch(changeRegion(city, true, loadNeeded)),
  };
}

export const MobileLocationSwitcherContainer = connect<
  IMobileLocationSwitcherStoreProps,
  IMobileLocationSwitcherDispatchProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(MobileLocationSwitcher);
